/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @enum {string}
 */

export const PurchaseDeliveryStatus = {
  Delivered: "DELIVERED",
  PendingDelivery: "PENDING_DELIVERY",
  PendingPayment: "PENDING_PAYMENT",
} as const;

export type PurchaseDeliveryStatus =
  (typeof PurchaseDeliveryStatus)[keyof typeof PurchaseDeliveryStatus];

export type PurchaseDeliveryStatusEnumType = typeof PurchaseDeliveryStatus;
export type PurchaseDeliveryStatusOptional = PurchaseDeliveryStatus;
export type PurchaseDeliveryStatusTrackedI = PurchaseDeliveryStatus;
export type PurchaseDeliveryStatusTracked = PurchaseDeliveryStatus;
export type PurchaseDeliveryStatusMetaI = EnumMetaType<
  PurchaseDeliveryStatusEnumType,
  PurchaseDeliveryStatus
>;
export const PurchaseDeliveryStatusMeta = typeMetaEnum<
  PurchaseDeliveryStatusEnumType,
  PurchaseDeliveryStatus
>("PurchaseDeliveryStatus", PurchaseDeliveryStatus);
export function transformDatesPurchaseDeliveryStatus(
  model: PurchaseDeliveryStatus,
) {}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
